import * as React from "react";
import { computed } from "mobx";
import { observer, Provider } from "mobx-react";
import { Area } from "../General/Area";
import { AreaBody } from "../General/AreaBody";
import { AppStore } from "../Stores/AppStore";
import { Strings } from "../Stores/StringsStore";
import { DocumentList } from "../Document/DocumentList";
import { DocumentPreviews } from "../Document/DocumentPreviews";
import { FavouriteUIStore } from "../Stores/FavouriteUIStore";
import { Toolbar } from "../General/Toolbar";
import { CloseButton } from "../Buttons/CloseButton";
import { ViewList } from "../Buttons/ViewList";
import { ViewCard } from "../Buttons/ViewCard";
import { Urls } from "../Urls";
import { RefreshButton } from "../Buttons/RefreshButton";
import { DownloadButton } from "../Buttons/DownloadButton";
import { PreviewStore } from "../Stores/PreviewStore";
import { Download } from "../Document/DocumentsView";
import { OfflineStatus, FileResultInfo } from "../DocumentReader";

@observer
export class MyFavourite extends React.Component<{}, {}> {

	store: FavouriteUIStore = new FavouriteUIStore();
	previewStore: PreviewStore = new PreviewStore("favourites");
	initialStatus: OfflineStatus[];

	componentDidMount() {
		AppStore.setTitle(Strings.appNavigation.favoriteLinkText);
		this.previewStore.loadSettings();
		this.store.triggerSearch();
		this.initialStatus = this.store.searchResult.documents.map((file, array) => { return file.status });
	}

	componentDidUpdate() {
		AppStore.setTitle(Strings.appNavigation.favoriteLinkText);
		this.store.triggerSearch();
	}

	handleCancel = () => {
		AppStore.keepOnPage(Urls.home);
	}

	handleRefresh = () => {
		this.store.triggerSearch();
	}

	@computed get downloadableFiles(): FileResultInfo[] {
		return this.store.searchResult.documents.filter(f => f.status === OfflineStatus.None || f.status === OfflineStatus.Update || f.status === OfflineStatus.Error);
	}

	@computed get canDownload(): boolean {
		return this.downloadableFiles.length > 0;
	}

	handleDownloadAll = () => {
		this.downloadableFiles.forEach((file) => {
			let status = file.status;
			if (status === OfflineStatus.Update) {
				Download.requestUpdate(file);
			}
			else if (status === OfflineStatus.Error) {
				let index = this.store.searchResult.documents.indexOf(file);
				if (this.initialStatus[index] === OfflineStatus.Update) {
					Download.requestUpdate(file)
				}
				else {
					Download.requestDownload(file);
				}
			}
			else if (status === OfflineStatus.None) {
				Download.requestDownload(file);
			}
		});
	}

	render() {
		return <Provider store={this.store}>
			<Area>
				<AreaBody>
					<Toolbar>
						<span className="buttongroup is--buttongroup-right">
							<CloseButton onClick={this.handleCancel} testId="closeButton" />
						</span>
						<span className="buttongroup is--buttongroup-left">
							<RefreshButton onClick={this.handleRefresh} testId="refreshButton" />
							{
								AppStore.context.sessionDetails.isApp ?
									<DownloadButton onClick={this.handleDownloadAll} disabled={!this.canDownload} />
									: null
							}
						</span>
						<span className="buttongroup is--buttongroup-right">
							<ViewList store={this.previewStore} />
							<ViewCard store={this.previewStore} />
						</span>
					</Toolbar>
					<div className="area-grid__body-content">
						<div className="content-main recent-filelist-container">
							<h1>{Strings.appNavigation.favoriteLinkText}</h1>
							{!this.previewStore.showPreviews ? <DocumentList showValidities={true} /> : <DocumentPreviews />}
						</div>
					</div>
				</AreaBody>
			</Area>
		</Provider>;
	}
}